import SRCustomerPreview from "./sr-customerpreview.container";

export default SRCustomerPreview;
